import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useForm } from '@/util/useForm';
import { getlist, postlist, getPointsRule } from '@/api/operation/newbiegift';
import { watch } from 'vue-demi';
import { message } from 'ant-design-vue';
import SingleImageUpload from '@/component/single-image-upload.vue';
import CustomModal from '@/component/custom-modal.vue';
import NEditor from '@/component/NForm/NEditor/NEditor.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'newbiegift',
  setup(__props) {

const form = useForm();
const visible = ref<boolean>(false);
const visibles = ref<boolean>(false);
const rule = ref<any>();
const obtained = ref<any>('选择新人优惠券');
const obtaineds = ref<any>('选择新人优惠券');

const editStatus = ref<boolean>(true);
function onEdit() {
  editStatus.value = false;
}
// 页面渲染
const initial = ref();
async function query() {
  const res = await getPointsRule();
  initial.value = res;
  poster_image.value = initial.value.poster_image;
  if(initial.value.rule ) rule.value = initial.value.rule;
  if(initial.value.obtained) obtained.value = initial.value.obtained;
  if(initial.value.obtaineds) obtaineds.value = initial.value.obtaineds;
  console.log(rule.value);
}
query();

function invitee() {
  visibles.value = true;
}
function inviteeOk(e) {
  visibles.value = false;
}
function inviter() {
  visible.value = true;
}
function inviterOk(e) {
  console.log(e);
  visible.value = false;
}
const columns = [
  {
    title: '优惠卷ID',
    dataIndex: 'id',
  },
  {
    title: '名称',
    dataIndex: 'name',
  },
  {
    title: '内容',
    key: 'money',
    // dataIndex: 'money',
    scopedSlots: { customRender: 'money' },
  },
  {
    title: '类型',
    // dataIndex: 'type',
    key: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '有效期',
    // dataIndex: 'end_time',
    key: 'end_time',
    scopedSlots: { customRender: 'end_time' },
  },
  {
    title: '状态',
    // dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
  },
];
// 获取表格勾选数据
const invitee_coupon = ref();
const inviter_coupon = ref();
const selectedRowKeys = (id, invitee) => {
  invitee_coupon.value = id[0];
  obtained.value = invitee[0].name;
  // console.log(invitee_coupon.value);
};
function onSelectChange(id, inviter) {
  inviter_coupon.value = id[0];
  obtaineds.value = inviter[0].name;
  // console.log(inviter_coupon);
  // console.log(inviter);
}
// 渲染表格数据
const total = ref();
const queryParams = ref();
async function fatc(params = queryParams.value) {
  const res = await getlist(params);
  total.value = res.detail;
  // console.log( total.value);
}
watch(
  queryParams,
  (newVal, oldval) => {
    fatc();
  },
  {
    immediate: true,
  }
);
// console.log(total);
const award_discount = ref();
const forms = useForm();
// 搜索
async function submit() {
  queryParams.value = forms.value.getFormValue();
}
// 清空
function clearForm() {
  forms.value.resetFields();
  queryParams.value = { current: 1 };
  award_discount.value = '';
}

// 图片上传
const is_loading = ref(false);
const form_item_layout = ref({
  labelCol: { span: 3 },
  wrapperCol: { span: 21 },
});
const preview_image = ref();
const is_show_img_modal = ref(false);
const UPLOAD_DIR = {
  background_image: 'operation/background-image',
};

function beforeCommonUpload(file: any) {
  if (file.size / 1024 / 1024 > 2) {
    message.error('上传图片大小不能超过2M');
    return false;
  }
}
const poster_image = ref();
function handlePreview(imageUrl: string) {
  preview_image.value = imageUrl;
  is_show_img_modal.value = true;
}
// 保存
async function onSave(e) {
  e.preventDefault();
  const res = form.value.getFormValue();
  form.value.validateFields((err, values) => {
    if (!err) {
      if (!rule.value || !poster_image.value) {
        message.error('请填写必填项');
        return;
      } else {
        postlist({
          title: res.title,
          desc: res.desc,
          invitee_coupon: invitee_coupon.value,
          inviter_coupon: inviter_coupon.value,
          poster_image: poster_image.value,
          rule: rule.value,
          obtained: obtained.value,
          obtaineds: obtaineds.value,
        });
      }
    }
  });
}

return { __sfc: true,form, visible, visibles, rule, obtained, obtaineds, editStatus, onEdit, initial, query, invitee, inviteeOk, inviter, inviterOk, columns, invitee_coupon, inviter_coupon, selectedRowKeys, onSelectChange, total, queryParams, fatc, award_discount, forms, submit, clearForm, is_loading, form_item_layout, preview_image, is_show_img_modal, UPLOAD_DIR, beforeCommonUpload, poster_image, handlePreview, onSave, SingleImageUpload, CustomModal, NEditor }
}

})